// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import OSTYPE from './metaData/osType'
export default {
  state: OSTYPE,
  actions
}
